import React, { useState, useEffect } from 'react';
import { schoolData } from '../../lib/supabase';
import { notifications } from '../../mockData/notifications';

// Simple icon component to replace lucide-react
const Icon = ({ name, size = 20, className = "" }) => {
  const icons = {
    user: "👤",
    bell: "🔔",
    calendar: "📅",
    dollar: "💰",
    "dollar-sign": "💰",
    book: "📚",
    file: "📄",
    "file-text": "📄",
    users: "👥",
    award: "🏆",
    message: "💬",
    "message-circle": "💬",
    home: "🏠",
    menu: "☰",
    x: "✕",
    search: "🔍",
    chevronDown: "▼",
    star: "⭐",
    clock: "⏰",
    mapPin: "📍",
    phone: "📞",
    mail: "📧",
    alert: "⚠️",
    filter: "🔽",
    pin: "📌",
    download: "⬇️",
    paperclip: "📎",
    send: "➤",
    plus: "➕",
    check: "✓",
    triangle: "⚠️",
    card: "💳",
    wifi: "📶",
    monitor: "💻",
    tablet: "📱",
    smartphone: "📱",
    camera: "📷",
    headphones: "🎧",
    megaphone: "📢",
    info: "ℹ️",
    settings: "⚙️",
    "help-circle": "❓",
    shield: "🛡️",
    "calendar-days": "🗓️"
  };
  
  return (
    <span 
      className={className}
      style={{ 
        fontSize: `${size}px`, 
        display: 'inline-block',
        lineHeight: 1
      }}
    >
      {icons[name] || "?"}
    </span>
  );
};

// Notification Page Component
const NotificationPage = ({ onBack }) => (
  <div style={{minHeight: '100vh', backgroundColor: '#f3f4f6'}}>
    <div style={{
      background: 'linear-gradient(to right, #3b82f6, #2563eb)',
      color: 'white',
      padding: '16px',
      boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)'
    }}>
      <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
        <button 
          onClick={onBack}
          style={{
            color: 'white',
            background: 'none',
            border: 'none',
            padding: '4px',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '18px'
          }}
        >
          ←
        </button>
        <h1 style={{fontSize: '18px', fontWeight: '600'}}>即時訊息</h1>
        <Icon name="filter" size={20} style={{cursor: 'pointer'}} />
      </div>
    </div>
    
    {/* Filter Tabs */}
    <div style={{
      backgroundColor: 'white',
      display: 'flex',
      borderBottom: '1px solid #e5e7eb'
    }}>
      <button style={{
        flex: 1,
        padding: '12px',
        backgroundColor: 'white',
        border: 'none',
        borderBottom: '2px solid #3b82f6',
        color: '#3b82f6',
        fontWeight: '500',
        cursor: 'pointer'
      }}>
        全部
      </button>
      <button style={{
        padding: '12px 16px',
        backgroundColor: 'white',
        border: 'none',
        color: '#6b7280',
        cursor: 'pointer'
      }}>
        已讀註
      </button>
    </div>

    {/* Search Bar */}
    <div style={{
      backgroundColor: 'white',
      padding: '12px 16px',
      borderBottom: '1px solid #e5e7eb'
    }}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        backgroundColor: '#f3f4f6',
        borderRadius: '8px',
        padding: '8px 12px',
        gap: '8px'
      }}>
        <Icon name="search" size={16} />
        <input 
          type="text"
          placeholder="搜尋"
          style={{
            border: 'none',
            backgroundColor: 'transparent',
            outline: 'none',
            flex: 1,
            fontSize: '14px',
            color: '#6b7280'
          }}
        />
      </div>
    </div>

    {/* Notifications List */}
    <div style={{backgroundColor: '#f3f4f6'}}>
      {notifications.map(notification => (
        <div key={notification.id} style={{
          backgroundColor: 'white',
          borderBottom: '1px solid #e5e7eb',
          padding: '12px 16px',
          display: 'flex',
          alignItems: 'flex-start',
          gap: '12px',
          position: 'relative'
        }}>
          {/* Status Indicator */}
          <div style={{
            width: '8px',
            height: '8px',
            borderRadius: '50%',
            backgroundColor: notification.isRead ? 'transparent' : '#ef4444',
            marginTop: '6px',
            flexShrink: 0
          }} />
          
          {/* Avatar */}
          <img 
            src={notification.avatar} 
            alt="Avatar"
            style={{
              width: '40px',
              height: '40px',
              borderRadius: '50%',
              objectFit: 'cover',
              flexShrink: 0
            }}
          />
          
          {/* Content */}
          <div style={{flex: 1, minWidth: 0}}>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'flex-start',
              marginBottom: '4px'
            }}>
              <h3 style={{
                fontSize: '16px',
                fontWeight: '500',
                color: '#1f2937',
                margin: 0,
                lineHeight: '1.2'
              }}>
                {notification.title}
              </h3>
              <div style={{display: 'flex', gap: '8px', alignItems: 'center'}}>
                <Icon name="star" size={16} style={{color: '#d1d5db', cursor: 'pointer'}} />
                <Icon name="pin" size={16} style={{color: '#d1d5db', cursor: 'pointer'}} />
              </div>
            </div>
            
            <p style={{
              fontSize: '14px',
              color: '#4b5563',
              margin: '0 0 4px 0',
              lineHeight: '1.3'
            }}>
              {notification.sender}
            </p>
            
            <p style={{
              fontSize: '14px',
              color: '#6b7280',
              margin: '0 0 8px 0',
              lineHeight: '1.4'
            }}>
              {notification.content}
            </p>
            
            <p style={{
              fontSize: '14px',
              color: '#3b82f6',
              margin: 0,
              lineHeight: '1.3'
            }}>
              {notification.contentEn}
            </p>
            
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '4px',
              marginTop: '8px'
            }}>
              <Icon name="calendar" size={12} style={{color: '#9ca3af'}} />
              <span style={{
                fontSize: '12px',
                color: '#9ca3af'
              }}>
                {notification.timestamp}
              </span>
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
);

// News Section Component
const NewsSection = () => {
  const [newsData, setNewsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const styles = {
    card: {
      backgroundColor: 'white',
      borderRadius: '8px',
      boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
      marginBottom: '24px',
      padding: '16px'
    },
    title: {
      fontSize: '20px',
      fontWeight: '600',
      color: '#1f2937',
      marginBottom: '16px'
    }
  };

  useEffect(() => {
    const fetchNews = async () => {
      try {
        setLoading(true);
        
        // Check if schoolData service is available
        if (!schoolData || typeof schoolData.getSchoolNews !== 'function') {
          console.error('School data service not available');
          setError('School data service not available');
          return;
        }
        
        const { data, error } = await schoolData.getSchoolNews();
        
        if (error) {
          console.error('Error fetching school news from database:', error);
          setError(error || 'Failed to load school news');
          return;
        }
        
        setNewsData(data || []);
      } catch (err) {
        console.error('Error fetching school news:', err);
        setError(err.message || 'Failed to load school news');
      } finally {
        setLoading(false);
      }
    };

    fetchNews();
  }, []);

  if (loading) {
    return (
      <div style={styles.card}>
        <h2 style={styles.title}>學校最新消息</h2>
        <div style={{textAlign: 'center', padding: '20px'}}>載入中...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={styles.card}>
        <h2 style={styles.title}>學校最新消息</h2>
        <div style={{textAlign: 'center', padding: '20px', color: 'red'}}>
          錯誤: {error}
        </div>
      </div>
    );
  }

  if (!newsData || newsData.length === 0) {
    return (
      <div style={styles.card}>
        <h2 style={styles.title}>學校最新消息</h2>
        <div style={{textAlign: 'center', padding: '20px'}}>沒有最新消息</div>
      </div>
    );
  }

  return (
    <div style={styles.card}>
      <h2 style={styles.title}>學校最新消息</h2>
      <div style={{display: 'grid', gap: '16px'}}>
        {newsData.map(news => (
          <div key={news.id} style={{
            border: '1px solid #e5e7eb',
            borderRadius: '8px',
            overflow: 'hidden',
            backgroundColor: '#fafafa'
          }}>
            {news.image_url && (
              <img 
                src={news.image_url} 
                alt={news.title}
                style={{width: '100%', height: '200px', objectFit: 'cover'}}
              />
            )}
            <div style={{padding: '16px'}}>
              <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'start', marginBottom: '8px'}}>
                <h3 style={{fontSize: '18px', fontWeight: '600', color: '#1f2937'}}>{news.title}</h3>
                <span style={{
                  padding: '4px 8px',
                  borderRadius: '4px',
                  fontSize: '12px',
                  backgroundColor: news.featured ? '#dbeafe' : '#f3f4f6',
                  color: news.featured ? '#1e40af' : '#6b7280'
                }}>
                  {news.featured ? '焦點' : '一般'}
                </span>
              </div>
              <p style={{color: '#6b7280', fontSize: '14px', marginBottom: '8px', lineHeight: '1.5'}}>{news.content}</p>
              <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '12px', color: '#6b7280'}}>
                <span>{news.date} • {news.author}</span>
                <span style={{
                  padding: '2px 6px',
                  borderRadius: '4px',
                  backgroundColor: '#e5e7eb'
                }}>
                  {news.category}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

// Main News and Notification Module Component
const NewsAndNotificationModule = ({ activeTab, onBack }) => {
  // Render based on active tab
  if (activeTab === 'notification') {
    return <NotificationPage onBack={onBack} />;
  } else if (activeTab === 'news') {
    return <NewsSection />;
  }
  
  // Default case - show both components
  return (
    <div>
      <NewsSection />
      {/* Additional notification summary could go here */}
    </div>
  );
};

export default NewsAndNotificationModule;
export { NotificationPage, NewsSection };
